import React, { useEffect, useRef } from 'react';
import '../BitsStyles/Featurechoose.css';

const features = [
  {
    icon: 'bi-people-fill',
    accent: '#3B82F6',
    title: 'Senior Business Experts',
    description: 'Leverage our seasoned professionals to transform your ideas into impactful solutions, keeping you ahead in today\'s fast-paced market.',
  },
  {
    icon: 'bi-grid-3x3-gap-fill',
    accent: '#06B6D4',
    title: 'One-Stop Solution',
    description: 'From web apps to billing systems, our all-in-one ecosystem handles your full scope of business technology needs under one roof.',
  },
  {
    icon: 'bi-lightning-charge-fill',
    accent: '#6366F1',
    title: 'Talented Resources',
    description: 'Access top-tier global talent delivering high-quality software solutions with expertise in mobile, web apps, and business automation.',
  },
  {
    icon: 'bi-shield-fill-check',
    accent: '#22C55E',
    title: 'Security & Support',
    description: 'Enterprise-grade security with continuous, reliable support that keeps your systems secure, operational, and optimized for growth.',
  },
];

const stats = [
  { number: '10+', label: 'Projects Delivered' },
  { number: '10+', label: 'Happy Clients' },
  { number: '99%', label: 'Client Satisfaction' },
];

const Featurechoose = () => {
  const cardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fc-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    cardsRef.current.forEach(el => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="fc-section">
      <div className="fc-orb fc-orb1"></div>
      <div className="fc-orb fc-orb2"></div>

      <div className="fc-inner">
        {/* Header */}
        <div className="fc-header">
          <div className="section-eyebrow">
            <span>Why Choose Us</span>
          </div>
          <h2 className="h-section">
            Why choose{' '}
            <span className="grad-text">Bellary Info Tech Solutions</span>
          </h2>
          <p className="body-lg fc-subtitle">
            We combine technical expertise with business acumen to deliver solutions that drive real results for your organisation.
          </p>
        </div>

        {/* Stats row */}
        <div className="fc-stats">
          {stats.map((s, i) => (
            <div key={i} className="fc-stat" ref={el => cardsRef.current[i] = el}>
              <div className="fc-stat-num">{s.number}</div>
              <div className="fc-stat-lbl">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Feature cards */}
        <div className="fc-grid">
          {features.map((f, i) => (
            <div
              key={i}
              className="fc-card"
              ref={el => cardsRef.current[stats.length + i] = el}
              style={{ '--fc-accent': f.accent, animationDelay: `${i * 0.1}s` }}
            >
              <div className="fc-icon" style={{ background: `${f.accent}18`, color: f.accent }}>
                <i className={`bi ${f.icon}`}></i>
              </div>
              <h3 className="fc-card-title">{f.title}</h3>
              <p className="fc-card-desc">{f.description}</p>
              <div className="fc-card-bar" style={{ background: f.accent }}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Featurechoose;
